import { configureStore } from '@reduxjs/toolkit';
import { adminApi } from '../../src/slices/admin/admin'; 


const store = configureStore({
    reducer: {
        [adminApi.reducerPath]: adminApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }).concat(adminApi.middleware),
    devTools: process.env.NODE_ENV !== 'production', 
});

export default store;
